import { defineStore } from 'pinia';

export const useRuleManagerStore = defineStore('rule_manager', {
  state: () => ({
    selectedRule: {} as any,
  }),

  actions: {},
});
